import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Container, Segment, Sticky, Grid, Input, Transition, Divider, Loader } from 'semantic-ui-react';
import { Button, Form, Icon, Message, Progress, Image } from 'semantic-ui-react';
import { Link, Redirect , useParams} from 'react-router-dom';
import { AppState } from '../../context';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import Cookies from 'js-cookie';


const Ques2 = ({inst}) => {
  const someContext = useContext(AppState);
  const {
    firstlogin,
    setFirstLogin,
    user,
    setUser,
    firsttimeuser,
    setFirsttimeuser,
    globallogged,
    setGlobalLogged,
    familyMembers,
    admin,
  } = someContext;
  const contextRef = createRef();
  const {userid} = useParams();

  const PageHeader = () => {
    var header = inst ? inst : "Homecare";
    return (
      <Segment
        basic
        style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
        fluid="true"
      >
        <Grid columns={2}>
          <Grid.Column width='3' />
          <Grid.Column width='10'>
            <Header
              as={Link}
              to="/"
              inverted
              content={header}
              size="large"
              color="black"
              style={{ cursor: "default" }}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  };
  var redirect= !inst  ? `/familymembers/add/secondfam/${userid}/0`: `/${inst}/familymembers/add/secondfam/${userid}/0`
  var redirect2 = !inst ? `/familymembers/register/recommended/${userid}` : `/${inst}/familymembers/register/recommended/${userid}`
  var redirect3 = (admin == 'Samarth' || (Cookies.get('logged') == 'Samarth')) ? "/samarth/admin" : `/familymembers/summary/${userid}`;
  return (<div ref={contextRef}>
      <PageHeader />
      <Sticky context={contextRef} >
        <Grid textAlign='center' style={{ height: '10vh' }} padded>
          <Divider hidden />
          <Grid.Row>
            <Grid.Column style={{ marginLeft: "30px", marginRight: "30px", maxWidth: 450 }}>
              <Progress percent={75} indicating />
            </Grid.Column>
          </Grid.Row>
          
            <Grid.Row>
              <Grid.Column style={{ maxWidth: 450 }}>
                <Header as="h5">
                  Do you want to add another family member to your account so you can assign tasks back and forth? They will be able to see all caregiver progress too!
                </Header>
                <Form size='large' >
                 

          <Button color='teal' as={Link} exact to={redirect} fluid size='large' >
                      Continue
        </Button>
        <Button color='violet' as={Link} exact to={familyMembers[userid] && familyMembers[userid]["careBool"] ? redirect2:redirect3} onClick={()=> setGlobalLogged(true)} fluid size='large' >
                      Skip for Now
        </Button>
                

                </Form>
                <Message>
                  Why do you need to add caregivers?<a href='/signup'> Here's why?</a>
                </Message>
              </Grid.Column>
            </Grid.Row>


          </Grid>

       
      </Sticky>
      {/* {redirect && username? <Redirect to={`/familymembers/caregiver`} push={true} /> : ""} */}
    </div>
  );
};

export default Ques2;